"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FearAbilityHandler = exports.FearActorAbilityFactory = exports.FearAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
class FearAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Fear;
        this.__typeName = "Fear";
    }
}
exports.FearAbilityArgs = FearAbilityArgs;
let FearActorAbilityFactory = class FearActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Fear", "OneEnemies", 2);
    }
};
FearActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Fear")
], FearActorAbilityFactory);
exports.FearActorAbilityFactory = FearActorAbilityFactory;
let FearAbilityHandler = class FearAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.applyDebuff({
                    sequence: sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_2.StunEffectArgs(),
                    onApplied(sequence) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EngulfingDarkness"));
                    }
                });
            }
        });
    }
};
FearAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Fear)
], FearAbilityHandler);
exports.FearAbilityHandler = FearAbilityHandler;
